import { createReducer } from '@reduxjs/toolkit';

import { ASSET_TOKEN_STATUS, ASSETS_TYPES } from '../../constants/constants';
import { AssetDetailsStateType } from '../../types';
import {
  getAssetDetails,
  setAssetsDetailsLoading,
} from '../actions/asset-details';

const initialState: AssetDetailsStateType = {
  data: {
    details: {
      agreementLinks: [],
      dateOfReceipt: new Date(),
      documentLinks: [],
      financialClaim: 0,
      actualCount: 0,
      blockchainTransactionId: '',
      holdCount: 0,
      lockedCount: 0,
      id: '',
      initialDate: new Date(),
      issuer: '',
      issuerTIN: '',
      issuingInfo: {
        decision: {
          checksum: '',
          documentType: 'PAYMENT_SIGNED',
          extension: '',
          filename: '',
          filepath: '',
          id: 0,
          issuingInfoIds: [],
          mainDecisionId: 0,
          signature: '',
          signed: true,
          weight: 0,
        },
        finalizedDate: new Date(),
        expiryDate: new Date(),
        financialClaim: 0,
        id: 0,
        initialDate: new Date(),
        initialPurchasers: [],
        initialTokenNames: [],
        initialValue: 0,
        issuer: '',
        issuerId: 0,
        name: '',
        orderItemId: null,
        status: ASSET_TOKEN_STATUS.ACTIVE,
        tokenId: '',
        tokenType: ASSETS_TYPES.SIMPLE,
      },
      owner: '',
      ownerTIN: '',
      sender: '',
      senderTIN: '',
      senderValidator: '',
      recipientValidator: '',
      status: ASSET_TOKEN_STATUS.ACTIVE,
      type: ASSETS_TYPES.SIMPLE,
    },
  },
  loading: {
    details: false,
    assets: false,
  },
};

const assetDetailsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAssetsDetailsLoading, (state, action) => {
    state.loading[action.payload.name] = action.payload.value;
  });

  builder.addCase(getAssetDetails.fulfilled, (state, action) => {
    state.data.details = action.payload;
  });
});

export default assetDetailsReducer;
